<template>
    <div class="h-dvh w-full flex items-center justify-center bg-brand-gray">

<UContainer>
      <div class="flex flex-col text-white gap-8">
      <div class="text-6xl uppercase">error 404</div>
      <div class="text-3xl uppercase">Oups… Vous êtes perdu ? 🐾</div>

        <div class="grid xl:grid-cols-2">
          <div>
          <img class="object-cover w-full h-full" src="https://www.novagroupe.ch/wp-content/uploads/2025/03/404-1.webp" alt="">
          </div>
          <div class="bg-white text-brand-gray flex justify-center items-center">
            <div class="p-12 flex flex-col gap-8 base mb-10 md:mt-6 md:ml-6 items-start">
            <p>Il semblerait que cette page ait disparu… ou peut-être que Nova a marché sur le clavier ! 🐾</p>

            <p>Ne vous inquiétez pas, vous pouvez revenir à l’accueil.</p>

            <p>Pendant ce temps, Nova va enquêter sur cette mystérieuse disparition… 🕵️‍♂️😼</p>

            <UButton @click="navigateTo('/')">Retour à la page principale</UButton>
            </div>
          </div>
        </div>


        <p class="text-almond-frost-100">* Nova est la mascotte du bureau, présent 24h/24 depuis 2023. Toujours à nos côtés, il veille sur l’équipe, explore chaque recoin et s’invite parfois sur les claviers.</p>
    </div>
</UContainer>
    </div>
</template>

<script>
export default {
  methods: {
    goBack() {
      this.$router.push('/')
    }
  }
}
</script>
